/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CityAndPrice } from './';
import {
    CityAndPriceFromJSON,
    CityAndPriceFromJSONTyped,
    CityAndPriceToJSON,
} from './';

/**
 * 
 * @export
 * @interface JobAndPrice
 */
export interface JobAndPrice {
    /**
     * 
     * @type {Array<CityAndPrice>}
     * @memberof JobAndPrice
     */
    cityAndPrices: Array<CityAndPrice>;
    /**
     * 
     * @type {string}
     * @memberof JobAndPrice
     */
    humanId: string;
    /**
     * 
     * @type {string}
     * @memberof JobAndPrice
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof JobAndPrice
     */
    meanPrice: number;
    /**
     * 
     * @type {number}
     * @memberof JobAndPrice
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof JobAndPrice
     */
    url: string;
}

/**
 * Check if a given object implements the JobAndPrice interface.
 */
export function instanceOfJobAndPrice(value: object): value is JobAndPrice {
    if (!('cityAndPrices' in value) || value['cityAndPrices'] === undefined) return false;
    if (!('humanId' in value) || value['humanId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('meanPrice' in value) || value['meanPrice'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function JobAndPriceFromJSON(json: any): JobAndPrice {
    return JobAndPriceFromJSONTyped(json, false);
}

export function JobAndPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobAndPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'cityAndPrices': ((json['cityAndPrices'] as Array<any>).map(CityAndPriceFromJSON)),
        'humanId': json['humanId'],
        'label': json['label'],
        'meanPrice': json['meanPrice'],
        'price': json['price'],
        'url': json['url'],
    };
}

export function JobAndPriceToJSON(value?: JobAndPrice | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cityAndPrices': ((value['cityAndPrices'] as Array<any>).map((v) => CityAndPriceToJSON(v))),
        'humanId': value['humanId'],
        'label': value['label'],
        'meanPrice': value['meanPrice'],
        'price': value['price'],
        'url': value['url'],
    };
}

